<script>import * as d3 from "d3";
import { okhsl } from "../../../d3-mapp/color/index.js";
import BarPlot, {} from "./BarPlot.svelte";
import {
  timeRangeContextKey
} from "../time-plot-context.js";
import { getContext } from "svelte";
export let title = void 0;
export let yAxisLabel;
export let showAxis = true;
export let padding = 0.1;
export let interval = "auto";
export let data;
export let color = okhsl("steelblue");
const {
  timeScale,
  timeAxisDefinition
} = getContext(timeRangeContextKey);
let frequencyData = [];
$: {
  if ($timeScale) {
    const frequencyInterval = interval === "auto" ? $timeAxisDefinition ? $timeAxisDefinition.minorD3BaseTimeInterval : $timeScale.domain()[1].getTime() - $timeScale.domain()[0].getTime() >= 7 * 24 * 36e5 ? d3.timeDay.every(1) : d3.timeHour.every(1) : interval;
    const frequencyTable = data.reduce(
      (frqTable, datum) => {
        const start = frequencyInterval.floor(new Date(datum.time)).getTime();
        if (frqTable[start] === void 0) {
          const endDate = frequencyInterval.ceil(new Date(datum.time));
          const end = endDate.getTime() > start ? endDate.getTime() : frequencyInterval.offset(endDate, 1).getTime();
          const duration = end - start;
          frqTable[start] = {
            key: start,
            start: new Date(start + duration * padding),
            end: new Date(end - duration * padding),
            f: 1
          };
        } else {
          frqTable[start].f++;
        }
        return frqTable;
      },
      {}
    );
    frequencyData = Object.values(frequencyTable);
  }
}
</script>

<BarPlot
{title}
label={yAxisLabel}
{showAxis}
data={frequencyData}
{color}
/>